import {
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import { useEffect, useState } from "react";

// components / pages
import LoadingPage from "./LoadingPage";
import MobileShowcaseBetaPage from "./mobile/MobileShowcaseBetaPage";
import WebShowcaseBetaPage from "./web/WebShowcaseBetaPage";

import { herokuBaseUrl } from "../data/appConstants";
import { IShowcase, IShowcaseOrder } from "../types/types";

export interface ShowcasePageProps {
  showcases: IShowcase[];
}

function ShowcaseBetaPage() {
  const theme = useTheme();
  const mobileView = useMediaQuery(theme.breakpoints.down("xs"));
  const BASE_URL = herokuBaseUrl;

  const [showcaseData, setShowcaseData] = useState<Array<IShowcase>>([]);
  const [isFetching, setIsFetching] = useState(false);

  const reorder = (showcases: IShowcase[], orders: IShowcaseOrder[]) => {
    const sortedShowcases = orders.map(
      (order) =>
        showcases.filter((showcase) => showcase.showcase_id === order.showcase_id)[0]
    );
    return sortedShowcases;
  };

  useEffect(() => {
    const fetchStrapi = async () => {
      setIsFetching(true);
      const fetchOption = {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      };

      try {
        const fetches = [
          fetch(`https://${BASE_URL}/showcases`, fetchOption),
          fetch(`https://${BASE_URL}/preview-showcase-orders`, fetchOption),
        ];

        const [showcaseResponse, showcaseOrderResponse] = await Promise.all(
          fetches
        );

        const showcases = await showcaseResponse.json();
        const showcaseOrder = await showcaseOrderResponse.json();
        const orderedShowcases = reorder(showcases, showcaseOrder[0].showcase_ids);
        setShowcaseData(orderedShowcases);
        setIsFetching(false);
      } catch (err) {
        console.log(err);
        setIsFetching(false);
      }
    };
    fetchStrapi();
  }, [BASE_URL]);

  if (isFetching) {
    return <LoadingPage />;
  }

  return mobileView ? (
    <MobileShowcaseBetaPage
      showcases={showcaseData}
    />
  ) : (
    <WebShowcaseBetaPage
      showcases={showcaseData}
    />
  );
}

export default ShowcaseBetaPage;
